import React, { useState } from 'react'
import AppBar from '../components/AppBar'
import FormInput from '../components/FormInput'
import Gap from '../components/Gap'
import { handleBootpayVerification } from '../utils/bootpayAuth'
import { toastUtil } from '../utils/toast'

const PhoneVerificationTest: React.FC = () => {
  const [phone, setPhone] = useState('')
  const [error, setError] = useState('')
  const [isVerifying, setIsVerifying] = useState(false)
  const [verifiedPhone, setVerifiedPhone] = useState<string | null>(null)

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '')
    setPhone(value)
    if (error) {
      setError('')
    }
  }

  const handleVerify = async () => {
    setIsVerifying(true)
    setError('')

    await handleBootpayVerification(
      async (verifiedPhoneNumber: string) => {
        // 본인인증 성공
        setVerifiedPhone(verifiedPhoneNumber)
        toastUtil.success('본인인증이 완료되었습니다')
        setIsVerifying(false)
      },
      (errorMessage: string) => {
        // 본인인증 실패
        setError(errorMessage)
        toastUtil.error(errorMessage)
        setIsVerifying(false)
      },
      () => {
        // 본인인증 취소
        toastUtil.info('본인인증이 취소되었습니다')
        setIsVerifying(false)
      }
    )
  }

  return (
    <div className="w-full h-full flex flex-col">
      <AppBar title="본인인증 테스트" isBottomBorder />

      <div className="w-full flex-1 overflow-y-auto scrollbar-hide">
        <div className="app-container">
          <div className="flex flex-col px-20px pb-32px">
            <Gap height={24} />

            <FormInput
              label="핸드폰 번호 (선택사항)"
              name="phone"
              type="tel"
              value={phone}
              onChange={handlePhoneChange}
              placeholder="전화번호를 입력해주세요 (선택사항)"
              error={error}
              maxLength={11}
              readOnly={isVerifying}
            />

            {verifiedPhone && (
              <>
                <Gap height={16} />
                <div className="w-full py-12px px-16px bg-4B3621-80%-10% rounded-8px">
                  <div className="text-14px text-textColorText2 mb-4px">
                    인증된 전화번호
                  </div>
                  <div className="text-16px font-bold text-textColorText2">
                    {verifiedPhone}
                  </div>
                </div>
              </>
            )}

            <Gap height={24} />

            <button
              type="button"
              onClick={handleVerify}
              disabled={isVerifying}
              className={`
                w-full
                py-15px
                rounded-30px
                font-bold
                text-16px
                ${
                  isVerifying
                    ? 'cursor-not-allowed bg-4B3621-80%-10% text-textColorText3'
                    : 'cursor-pointer bg-4B3621-80% text-textColorText1W'
                }
              `}
            >
              {isVerifying ? '본인인증 중...' : '본인인증'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PhoneVerificationTest
